import { useNavigate } from 'react-router-dom'
import { BackButton } from './BackButton'
import styles from './MainToolbarContent.module.css'

export const MainToolbarContent = (): JSX.Element => {
    const navigate = useNavigate()

    const handleBackButtonClick = () => {
        navigate('/')
    }

    return (
        <div className={styles.MainToolbarContent}>
            <div className={styles.MainToolbarContent__StartContainer}>
                <BackButton onClick={handleBackButtonClick} />
            </div>
            <div className={styles.MainToolbarContent__CenterContainer}>
                <div className={styles.MainToolbarContent__Title}>
                    Settings
                </div>
            </div>
            <div className={styles.MainToolbarContent__EndContainer}>
            </div>
        </div>
    )
}